const Constants = {
    fatherBenYouTubeChannel: 'https://www.youtube.com/@benjaminkosnac5108',
};

export default Constants;